"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PostViewContentTypes_1 = require("../../../constants/PostViewContentTypes");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var translationHelper_1 = require("../../../helpers/translationHelper");
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ApartmentDescription = function (_a) {
    var propertyType = _a.propertyType, postData = _a.postData;
    var t = react_i18next_1.useTranslation('common').t;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var descriptionType = translationHelper_1.getDescriptionTypeByLanguage(currentLanguage);
    var resolveDescription = function () {
        var _a;
        return ((_a = postData.sections.apartment_info[0][descriptionType]) !== null && _a !== void 0 ? _a : postData.sections.apartment_info[0].description);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.apartment_description },
        react_1.default.createElement("p", { className: styles_module_scss_1.default.header }, propertyType === PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
            ? t('POST_PREVIEW.POST_PREVIEW')
            : propertyType === PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                ? t('POST_PREVIEW.POST_PREVIEW_COMMERCIAL')
                : propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                    ? t('POST_PREVIEW.POST_PREVIEW_HOUSE')
                    : t('POST_PREVIEW.POST_PREVIEW')),
        react_1.default.createElement("div", { className: classnames_1.default('text', styles_module_scss_1.default.about_apartment_description), dangerouslySetInnerHTML: { __html: resolveDescription() } })));
};
exports.default = ApartmentDescription;
